import { Blockquote, Amazon, InternalLink, AffiliateBanner } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  InternalLink,
  AffiliateBanner,
  React
};